import React, { useEffect, useMemo, useState } from "react";
import { Save, Search } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AdminContent() {
  const [items, setItems] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");
  const [saving, setSaving] = useState({});

  useEffect(() => {
    api.get("/admin/content")
      .then((r) => {
        setItems(r.data);
        const map = {};
        r.data.forEach((d) => { map[d.key] = { it: d.it || "", en: d.en || "" }; });
        setDrafts(map);
      })
      .finally(() => setLoading(false));
  }, []);

  const groups = useMemo(() => {
    const g = {};
    items.forEach((it) => {
      const section = it.key.split(".")[0];
      if (!g[section]) g[section] = [];
      g[section].push(it);
    });
    return g;
  }, [items]);

  const filtered = (list) => list.filter((it) => !q || it.key.toLowerCase().includes(q.toLowerCase()) || drafts[it.key]?.it?.toLowerCase().includes(q.toLowerCase()));

  const saveKey = async (key) => {
    setSaving((s) => ({ ...s, [key]: true }));
    try {
      await api.put(`/admin/content/${key}`, drafts[key]);
      toast.success("Salvato");
    } catch { toast.error("Errore"); }
    finally { setSaving((s) => ({ ...s, [key]: false })); }
  };

  return (
    <div className="p-6 lg:p-10" data-testid="admin-content-page">
      <div className="mb-8 flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs font-bold uppercase tracking-widest text-[#FF5A1F]">— Contenuti sito</div>
          <h1 className="font-display text-5xl uppercase text-[#0A0A0A] mt-2">Testi</h1>
          <p className="text-[#0A0A0A]/60 mt-2 max-w-xl">Modifica qui i testi di Home, Chi siamo, Servizi, Contatti e Landing. Ogni chiave ha due varianti: IT ed EN.</p>
        </div>
        <div className="flex items-center gap-2 border-2 border-[#0A0A0A] px-3 py-2 bg-white">
          <Search size={16} />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca chiave o testo…" className="bg-transparent focus:outline-none text-sm" data-testid="admin-content-search" />
        </div>
      </div>

      {loading ? <div className="text-[#0A0A0A]/50">Caricamento…</div> : (
        <div className="space-y-10">
          {Object.entries(groups).map(([section, list]) => {
            const shown = filtered(list);
            if (shown.length === 0) return null;
            return (
              <div key={section} data-testid={`content-section-${section}`}>
                <h2 className="font-display text-3xl uppercase text-[#0A0A0A] border-b-2 border-[#0A0A0A] pb-2 mb-4">{section}</h2>
                <div className="space-y-4">
                  {shown.map((it) => (
                    <div key={it.key} className="border-2 border-[#0A0A0A] p-4 bg-[#FAFAF7]" data-testid={`content-row-${it.key}`}>
                      <div className="flex items-center justify-between mb-3 gap-3 flex-wrap">
                        <code className="text-xs bg-[#0A0A0A] text-[#FAFAF7] px-2 py-1 font-mono">{it.key}</code>
                        <button onClick={() => saveKey(it.key)} disabled={saving[it.key]} className="btn-cta py-2 px-4 text-xs disabled:opacity-60" data-testid={`content-save-${it.key}`}>
                          <Save size={12} /> {saving[it.key] ? "..." : "Salva"}
                        </button>
                      </div>
                      <div className="grid md:grid-cols-2 gap-3">
                        <label className="block">
                          <span className="text-[10px] uppercase tracking-widest font-bold text-[#FF5A1F]">IT</span>
                          <textarea value={drafts[it.key]?.it ?? ""} onChange={(e) => setDrafts((d) => ({ ...d, [it.key]: { ...d[it.key], it: e.target.value } }))} rows={2} className="mt-1 block w-full border-2 border-[#0A0A0A] px-2 py-1 bg-white text-sm resize-y" data-testid={`content-input-it-${it.key}`} />
                        </label>
                        <label className="block">
                          <span className="text-[10px] uppercase tracking-widest font-bold text-[#0A0A0A]/60">EN</span>
                          <textarea value={drafts[it.key]?.en ?? ""} onChange={(e) => setDrafts((d) => ({ ...d, [it.key]: { ...d[it.key], en: e.target.value } }))} rows={2} className="mt-1 block w-full border-2 border-[#0A0A0A] px-2 py-1 bg-white text-sm resize-y" data-testid={`content-input-en-${it.key}`} />
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
